import { yupResolver } from "@hookform/resolvers/yup";
import { ChevronRightOutlined } from "@mui/icons-material";
import {
  Box,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  Theme,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import Button from "components/Overrides/Button/Button";
import { ROUTES } from "helpers/routes";
import storageUtils from "helpers/storageUtils";
import { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { sendMessageToTelegram } from "services/telegram";
import * as yup from "yup";

const schema = yup.object().shape({
  topic: yup.string().required("Topic is required"),
});

const topics = [
  "For investment",
  "For partnership",
  "For purchasing product/service",
];

const SelectTopic = () => {
  const theme: Theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const {
    handleSubmit,
    control,
    formState: { errors, isValid, isDirty },
  } = useForm<{ topic: string }>({
    mode: "all",
    resolver: yupResolver(schema),
    defaultValues: {},
  });
  const onSubmit = async (data: { topic: string }) => {
    const visitor: Visitor | null = storageUtils.getVisitorFromLocalStorage();

    if (visitor) {
      setLoading(true);
      await sendMessageToTelegram({
        ...data,
        ...visitor,
      });
      setLoading(false);
    }
    navigate(ROUTES.THANK_YOU);
  };

  const onError = (errors: any) => {
    console.log(errors);
  };

  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: 500,
        margin: "0 auto",
        borderRadius: 3,
        overflow: "hidden",
        marginTop: 6,
        padding: theme.spacing(2),
        paddingTop: theme.spacing(4),
        bgcolor: theme.palette.common.white,
      }}
    >
      <Stack spacing={4}>
        <Controller
          name="topic"
          control={control}
          render={({ field }) => (
            <FormControl
              fullWidth
              style={{ maxWidth: !isMobile ? 350 : "100%", margin: "0 auto" }}
            >
              <InputLabel id="demo-simple-select-label">
                Topic for discussion
              </InputLabel>
              <Select
                {...field}
                fullWidth
                labelId="demo-simple-select-label"
                label="Topic for discussion"
                error={!!errors.topic}
              >
                {topics.map((topic) => (
                  <MenuItem key={topic} value={topic}>
                    {topic}
                  </MenuItem>
                ))}
              </Select>
              {errors.topic && (
                <FormHelperText error>{errors.topic.message}</FormHelperText>
              )}
            </FormControl>
          )}
        />

        <Button
          loading={loading}
          variant="contained"
          disabled={!isValid || !isDirty}
          onClick={handleSubmit(onSubmit, onError)}
          style={{ paddingInline: theme.spacing(8) }}
          endIcon={<ChevronRightOutlined />}
        >
          Next
        </Button>
      </Stack>
    </Box>
  );
};

export default SelectTopic;
